import { mapKeys, snakeCase } from 'lodash';

import { getEnvironment } from '../utils.mjs';

import { buildCloudinaryUrl } from './cloudinary';

const { WB_ASSET_ENDPOINT, FF_WBRT_4997_HUB_USE_WB_ASSET_SERVICE } =
  getEnvironment();

/*
 * When TRUE, will pass all images through wb-asset-service
 */
export const wbAssetServiceEnabled = () =>
  FF_WBRT_4997_HUB_USE_WB_ASSET_SERVICE === 'true';

const buildUrlQuery = (params) =>
  new URLSearchParams(Object.entries(params)).toString();

/*
 * Removes Cloudinary transformation parameters that are not supported
 * in wb-asset service.
 */
const wbAssetTrasformParams = (params) => {
  // Remove the following params:
  //   1. `secure` since it's always true
  const { secure, ...cloudinaryParams } = params;
  const pars = mapKeys(cloudinaryParams, (_value, key) => snakeCase(key));

  // Note: this is a temporary client fix. We want to reset CDN cache for
  // images that were incorrectly cropped without having both width and height
  if (pars.crop === 'fill' && (!pars.height || !pars.width)) pars.crop = ''; // back end defaults to "fit" crop for no crop

  return pars;
};

/**
 * Redirects former cloudinary traffic through wb-asset-service so that we
 * could migrate images.
 *
 * Note: this only supports coudinary images.
 * For videos, generate url with cloud.video_url(publicId, transformation)
 *
 * @param {object} options
 * @param {string} options.publicId - image ID in cloudinary (or wb-asset).
 * @param {object} options.transformation - cloudinary transformation parameters
 * @returns {string} image URI
 */
export const wbAssetImageUrl = ({ publicId, transformation }) => {
  transformation ||= {};

  // Send both the original and the transformed files to wb-asset
  const cloudinaryUrl = buildCloudinaryUrl({ publicId });
  const transformedUrl = buildCloudinaryUrl({
    publicId,
    transforms: transformation,
  });

  const params = {
    cloudinary_url: cloudinaryUrl,
    transformed_cloudinary_url: transformedUrl,
    ...wbAssetTrasformParams(transformation),
  };

  return WB_ASSET_ENDPOINT + '/wb/assets?' + buildUrlQuery(params);
};
